import { EntranceContainer } from "~/_app/entrance/components/mobile/EntranceContainer";

export function MobileEntranceCSR() {
  /**
   * 데이터 필요시 여기서 패칭 작업
   */

  return <EntranceContainer />;
}
